var map = {
	"./arrow-down.svg": 620,
	"./arrow-left-week.svg": 336,
	"./arrow-right-small.svg": 252,
	"./arrow-right-week.svg": 231,
	"./burger.svg": 219,
	"./calendar-event.svg": 133,
	"./close.svg": 936,
	"./dschungel-wien-logo.svg": 593,
	"./refresh-cw.svg": 264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;